import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Checkbox, Table } from 'rsuite'
import { getAbbreviatedState } from '../../../services/helper'

const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, dataKey, ...props }) => {
    let status
    let bgColorClass
    if (dataKey === 'state' && rowData[dataKey]) {
        rowData[dataKey] = getAbbreviatedState('', rowData[dataKey])
    }
    if (dataKey === 'qaStatus') {
        status = rowData['approvedByManager'] === true ? 'Approved' : rowData['approvedByManager'] === false ? 'Rejected' : 'Pending'
        bgColorClass = status.toLowerCase() === 'approved' ? 'bg-green' : status.toLowerCase() === 'rejected' ? 'bg-red' : 'bg-yellow'
    }
    return (
        <Cell {...props} className="text-black">
            {dataKey === 'qaStatus' ? (
                <h5 style={{ width: '60px' }} className={`btn text-white ${bgColorClass}`}>
                    {status}
                </h5>)
                :
                rowData[dataKey]
            }
        </Cell>
    )
}

export const TableCell = ({ rowData, dataKey, onClick, ...props }) => {
    return (
        <Cell {...props} className="table-link full-vendors-table-cell text-black" id={rowData.id} title={rowData?.[dataKey]}>
            {rowData[dataKey]}
        </Cell>
    )
}


const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0, display: 'flex', alignItems: 'center', margin: 0 }}>
        <Checkbox
            value={rowData[dataKey]}
            onChange={onChange}
            checked={checkedKeys?.some(item => item === rowData[dataKey])}
        />
    </Cell>
);

const FullVendorList = ({ tabledata, total, vendorListColumns, listId, onGetTableData, currentTab, searchValue, checkedKeys, setCheckedKeys, fullVendorPage, setFullVendorPage, onSetRowLimit}) => {
    const dispatch = useDispatch()
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [tableData, setTableData] = useState([])
    const [totalData, setTotalData] = useState(0)
    const [sortColumn, setSortColumn] = useState('suppliername');
    const [sortType, setSortType] = useState('asc');
    let checked = false;
    let indeterminate = false;

    if (checkedKeys?.length === tabledata?.length) {
        checked = true;
    } else if (checkedKeys?.length === 0) {
        checked = false;
    } else if (checkedKeys?.length > 0 && checkedKeys?.length < tabledata?.length) {
        indeterminate = false
    }


    const handleCheckAll = (value, checked) => {
        const keys = checked ? tableData.map(item => item.id) : [];
        setCheckedKeys(keys);
    };

    const handleCheck = (value, checked) => {
        const keys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value);
        setCheckedKeys(keys);
    };

    useEffect(() => {
        onGetTableData(1, 10, 'full', "", "suppliername", "asc")
    }, [])

    useEffect(() => {
        if (!tabledata || tabledata?.length === 0) {
            setTableData([])
            setTotalData(0)
            return
        }
        setTableData(tabledata)
        setTotalData(total)
    }, [tabledata])

    const handleChangeLimit = dataKey => {
        setFullVendorPage(1);
        onSetRowLimit(dataKey);
        setLimit(dataKey);
        onGetTableData(1, dataKey, 'full', searchValue, "suppliername", "asc")
    }

    const handleChangePage = (event) => {
        setFullVendorPage(event)
        onGetTableData(event, limit, 'full', searchValue, sortColumn, sortType)
    }

    const headerElements = vendorListColumns.map((col, index) => {
        if (index === 1) {
            return (
                <Column
                    resizable
                    key={col.name}
                >
                    <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                    <LinkCell dataKey={col.name} />
                </Column>
            )
        }
       
        return (
            <Column
                resizable
                sortable
                key={col.name}
            >
                <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                <TableCell className='text-black' dataKey={col.name} />
                {/* <Cell className='text-black full-vendors-table-cell' dataKey={col.name} /> */}
            </Column>
        )
    })

    const handleSortColumn = (sortColumn, sortType) => {
        setSortColumn(sortColumn);
        setSortType(sortType);
        onGetTableData(fullVendorPage, limit, currentTab, searchValue, sortColumn, sortType)
    }

    return (
        <div className='full-vendor-list'>
            <div className={`border border-2 border-top-0`}>
                <Table
                    id='full-vendors-table'
                    className='full-vendors-table'
                    virtualized={true}
                    autoHeight
                    data={tableData}
                    sortColumn={sortColumn}
                    sortType={sortType}
                    onSortColumn={handleSortColumn}
                >
                    <Column width={50} align="center" >
                        <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Checkbox
                                checked={checked}
                                indeterminate={indeterminate}
                                onChange={handleCheckAll}
                            />
                        </HeaderCell>
                        <CheckCell dataKey="id" checkedKeys={checkedKeys} onChange={handleCheck} />
                    </Column>
                    {headerElements}
                </Table>
                <div className="full-vendor-table-pagination">
                    <Pagination
                        prev
                        next
                        first={true}
                        last={true}
                        maxButtons={5}
                        activePage={fullVendorPage}
                        showInfo
                        displayLength={limit}
                        lengthMenu={[
                            {
                                label: '10',
                                value: 10,
                            },
                            {
                                label: '20',
                                value: 20,
                            },
                            {
                                label: '30',
                                value: 30,
                            },
                            {
                                label: '50',
                                value: 50,
                            },
                            {
                                label: '100',
                                value: 100,
                            },
                        ]}
                        total={totalData}
                        onChangeLength={handleChangeLimit}
                        onChangePage={(event) => { handleChangePage(event) }}
                    />
                </div>
            </div>
        </div>
    )
}

export default FullVendorList